/**
 * SessionExpiredNotice — сообщение «сессия истекла, войди заново».
 *
 * Показывается ТОЛЬКО когда сервер явно отверг refresh-токен, то есть
 * продлить сессию не вышло и нужен ручной вход. При недоступности бэкенда
 * (5xx, обрыв сети) не появляется — там сессия жива, попытка повторится
 * сама при следующем действии.
 *
 * Раньше пользователь просто получал 401 в консоли и молча отваливающиеся
 * блоки: лента и профиль пустели без объяснения.
 */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function SessionExpiredNotice() {
  const { sessionExpired, dismissSessionExpired } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!sessionExpired) return null;

  const goLogin = () => {
    dismissSessionExpired();
    // Возвращаем туда же, где человека прервало.
    const from = location.pathname + location.search;
    navigate(`/login?return=${encodeURIComponent(from)}`);
  };

  return (
    <div style={S.wrap} role="alert">
      <div style={S.text}>
        <b style={S.title}>Сессия истекла</b>
        <span style={S.sub}>Войди заново, чтобы продолжить.</span>
      </div>
      <div style={S.actions}>
        <button type="button" style={S.primary} onClick={goLogin}>
          Войти
        </button>
        <button type="button" style={S.ghost} onClick={dismissSessionExpired}>
          Позже
        </button>
      </div>
    </div>
  );
}

const S = {
  wrap: {
    position: "fixed",
    left: "50%",
    bottom: 24,
    transform: "translateX(-50%)",
    zIndex: "var(--z-toast, 1100)",
    display: "flex",
    alignItems: "center",
    gap: 16,
    maxWidth: "calc(100vw - 32px)",
    padding: "var(--sp-3) var(--sp-5)",
    borderRadius: "var(--r-lg)",
    background: "var(--paper)",
    border: "1px solid var(--line)",
    boxShadow: "var(--shadow-lg)",
    color: "var(--ink)",
    fontSize: "var(--fs-base)",
  },
  text: { display: "flex", flexDirection: "column", gap: 2, minWidth: 0 },
  title: { fontWeight: "var(--fw-bold)" },
  sub: { color: "var(--ink-soft)", fontSize: "var(--fs-sm)" },
  actions: { display: "flex", gap: 8, flexShrink: 0 },
  primary: {
    padding: "var(--sp-2) var(--sp-4)",
    borderRadius: "var(--r-sm)",
    border: "none",
    background: "var(--accent)",
    color: "var(--ink-on-accent)",
    fontWeight: "var(--fw-bold)",
    fontSize: "var(--fs-sm)",
    cursor: "pointer",
  },
  ghost: {
    padding: "var(--sp-2) var(--sp-3)",
    borderRadius: "var(--r-sm)",
    border: "1px solid var(--line)",
    background: "transparent",
    color: "var(--ink-soft)",
    fontWeight: "var(--fw-semibold)",
    fontSize: "var(--fs-sm)",
    cursor: "pointer",
  },
};
